// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.tenth_anniversary_pages").length) return;
  window.addEventListener("load", () => {
    const addObserver = () => {
      const sections = document.querySelectorAll(".jsScrollAnimTarget");
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            entry.target.classList.add("jsScrollAnim");
            observer.unobserve(entry.target);
          } else {
            entry.target.classList.remove("jsScrollAnim");
          }
        });
      });
      sections.forEach((section) => {
        observer.observe(section);
      });
    };
    document.querySelector("body.tenth_anniversary_pages").style.display =
      "block";
    addObserver();
  });
});
